module.exports = __webpack_public_path__ + "img/favorite_icon.dcc7982f.svg";